import { SET_SINGLE_ITEM_PACK_LOCATION, SET_SINGLE_ITEM_PACK_MODE } from 'src/actions/actionType'

const initialState = {
  singleItemPack: false,
  locationName: '',
}

export default function PackingPreferencesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SINGLE_ITEM_PACK_MODE:
      return { ...state, singleItemPack: action.payload }
    case SET_SINGLE_ITEM_PACK_LOCATION:
      return { ...state, locationName: action.payload }
    default:
      return state
  }
}
